import { render, staticRenderFns } from "./CompanyScoreCompare.vue?vue&type=template&id=59907bf7"
import script from "./CompanyScoreCompare.vue?vue&type=script&lang=js"
export * from "./CompanyScoreCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports